import classNames from 'classnames';
import React from 'react';
import { ITranslateProps, translate } from '../../mixins/translate';

export interface ITotalRiskScoreDotProps extends ITranslateProps {
    value?: undefined | string;
}

class TotalRiskScoreDotComponent extends React.Component<ITotalRiskScoreDotProps, Record<string, unknown>> {
    public override render() {
        let text = '';
        if (this.props.value && this.props.value !== '0' && this.props.value !== 'null') {
            text = this.props.t(`ramsPriority.${this.props.value}`);
        }
        const classObject = {
            fa: true,
            'fa-square': this.props.value && this.props.value !== '0',
            'fa-square-o': !this.props.value || this.props.value === '0',
            // 'fa-square': this.props.value && isFinite(this.props.value),
            // 'fa-square-o': !this.props.value || !isFinite(this.props.value),
            fs16: true,
            ml20: true,
            [`icon-totalramscore-${this.props.value}`]: this.props.value,
        };
        return <span className={classNames(classObject)} title={text}></span>;
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TotalRiskScoreDot = translate()(TotalRiskScoreDotComponent);
